import type { JSX } from "react";

import { cn } from "../../lib/cn.js";
import { SVGLoader } from "../common/SVGLoader.js";

/**
 * RoboLabs logo mark. The source SVG lives at
 * src/assets/svgs/ic_robolabs_logo.svg and is optimised + inlined by
 * scripts/inline-svg.mjs. Colour follows `currentColor`; size follows the
 * wrapper (pass `h-8 w-8` etc. via className).
 */
export function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <SVGLoader
      src="ic_robolabs_logo"
      className={cn("text-sidebar-foreground", className)}
    />
  );
}
